<script>
    export let hidden = true;
    export let left = 0;
</script>

<div
    style="left:{left}px; display: {hidden?'none':'block'};"
    class="iconlayers-legend"
/>